import { render, staticRenderFns } from "./mycourseDetail.vue?vue&type=template&id=2f1c2686&scoped=true&"
import script from "./mycourseDetail.vue?vue&type=script&lang=js&"
export * from "./mycourseDetail.vue?vue&type=script&lang=js&"
import style0 from "./mycourseDetail.vue?vue&type=style&index=0&id=2f1c2686&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1c2686",
  null
  
)

export default component.exports